"use client";

import _isEqual from "lodash/isEqual";
import QueryString from "query-string";

import { ItemType, Item, buildURL } from "@thenounproject/lingo-core";

import { GalleryContext } from "../../components/kits/Kit";
import { NavPoint } from "./NavPoint";

export const buildItemUrl = (
  item: Item,
  context: Pick<NavPoint, "section" | "space" | "portal"> & { galleryContext?: string }
) => {
  if (!item) return null;
  const { space, portal, section } = context,
    currentParams = QueryString.parse(window.location.search),
    { type: itemType, version, asset } = item;

  const { shareToken } = asset || {};

  const params = {
    v: version,
    asset_token: shareToken || undefined,
    kit_token: currentParams.tkn || currentParams.kit_token || undefined,
    previous: currentParams.previous || undefined,
    context: undefined,
  };

  const directLinkTypes = [ItemType.asset, ItemType.gallery];
  if (item.status === "trashed") {
    params.context = GalleryContext.deleted;
  } else if (item.sectionId === null && item.itemId == null) {
    params.context = GalleryContext.recovered;
  } else if (item.sectionId && !directLinkTypes.includes(itemType)) {
    return buildURL(`/s/${section.urlId}`, { space, portal }, params, item.shortId);
  }

  return buildURL(`/a/${item.urlId}`, { space, portal }, params);
};
